import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button, Typography,
} from '@visionplanner/ui-react-material';

const ConfirmDialogStyledWrapper = styled.div`
    && .mdc-dialog__surface {
        border-radius: 4px;
        max-width: 600px;
        .mdc-dialog__content {
          color: ${({ theme }) => theme.blackText};
          padding-top: ${({ theme }) => theme.paddings.large};
        }
    }

`;

const ModalButtonStyledWrapper = styled.div`
    button {
        margin-right: ${({ theme }) => theme.margins.base};
    }
`;

/**
 * Shows a modal dialog that asserts whether the user is sure
 * they want to proceed with the initiated action.
 */

const ConfirmModal = ({
  title,
  children,
  showCloseIcon,
  handleConfirm,
  onCloseModal,
  confirmText,
  cancelText,
  dataTa,
  preventDismissalOnOutsideClick,
  open,
}) => (
  <ConfirmDialogStyledWrapper className="text-align-center">
    <Modal
      title={title}
      showCloseIcon={showCloseIcon}
      open={open}
      onClose={onCloseModal}
      preventDismissalOnOutsideClick={preventDismissalOnOutsideClick}
      dataTa={dataTa}
    >
      <ModalBody data-ta={`${dataTa}-body`}>
        <Typography use="normal-text">{children}</Typography>
        <ModalButtonStyledWrapper className="pad-t-lg">
          <Button buttonType="secondary" dataTa="confirm-dialog-confirm" onClick={handleConfirm}>{confirmText}</Button>
          <Button dataTa="confirm-dialog-cancel" onClick={onCloseModal}>{cancelText}</Button>
        </ModalButtonStyledWrapper>
      </ModalBody>
    </Modal>
  </ConfirmDialogStyledWrapper>
);

ConfirmModal.defaultProps = {
  showCloseIcon: false,
  confirmText: 'Yes',
  cancelText: 'No',
  preventDismissalOnOutsideClick: true,
  open: true,
};

ConfirmModal.propTypes = {
  /** Dialog header text. */
  title: PropTypes.string,
  /**
   * Custom content for the dialog body. If no children
   * are passed, a default text will be rendered.
   */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  /** Boolean prop to hide and show close icon inside the modal */
  showCloseIcon: PropTypes.bool,
  /** Callback that is invoked when the user triggers the default confirm button. */
  handleConfirm: PropTypes.func,
  /** Function which handles close event of the modal. */
  onCloseModal: PropTypes.func,
  /** Custom caption for the confirm button. */
  confirmText: PropTypes.string,
  /** Custom caption for the cancel button. */
  cancelText: PropTypes.string,
  /** Custom attribute for testing purposes. */
  dataTa: PropTypes.string,
  /** Prevent the dialog from closing when clicked outside of modal */
  preventDismissalOnOutsideClick: PropTypes.bool,
  /** Whether or not the Dialog is showing */
  open: PropTypes.bool,
};

export default ConfirmModal;
